
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 16.756h-3.082c-.241-1.486-1.525-2.628-3.078-2.628s-2.837 1.142-3.078 2.628H.5a.5.5 0 000 1h13.762c.241 1.487 1.524 2.629 3.078 2.629s2.837-1.142 3.078-2.629H23.5a.5.5 0 000-1zm-6.16 2.629c-1.174 0-2.129-.955-2.129-2.129s.955-2.128 2.129-2.128 2.129.954 2.129 2.128-.955 2.129-2.129 2.129zM.5 7.243h4.143c.241 1.487 1.525 2.628 3.078 2.628s2.837-1.141 3.078-2.628h12.7a.5.5 0 000-1H10.8c-.242-1.487-1.525-2.628-3.078-2.628S4.885 4.757 4.644 6.244H.5a.499.499 0 100 .999zm7.221-2.628c1.174 0 2.129.955 2.129 2.129a2.13 2.13 0 01-4.258 0c0-1.172.955-2.129 2.129-2.129z"}})])
          )
        }
      }
    